<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="isModalOpen" class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-50"
           @click.self="close"
      >
        <div class="relative bg-primary max-w-420 w-full rounded-4 pl-20 pt-20 pr-16 pb-12">
          <div class="text-app-color">
            <p class="text-22 font-black">Export</p>
            <p class="text-14 mt-3">Export the page.</p>

            <div class="flex items-center my-20">
              <p class="text-14 font-semibold mr-7">Choose format:</p>
              <SelectModule
                v-model="exportType"
                class="text-14 w-110 rounded-4"
                item-class="uppercase"
                selecte-class="uppercase font-semibold"
                :options="[{id: 1, name: 'pdf'}, {id: 2, name: 'docx'}]"
              />
            </div>
          </div>
          <div class="flex justify-end items-center">
            <ButtonModule
              text="Cancel"
              :has-hover="true"
              class="text-app-color text-15 mr-12"
              @click="close"
            />
            <ButtonModule
              text="Export"
              class="bg-link-color rounded-4 px-35 py-12 text-white text-15"
              @click="exportFile"
            />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'

import { preventBodyScroll, generateHTML } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import SelectModule from '@/components/shared/form-controls/SelectModule'
import { projectService } from '@/services'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: { ButtonModule, SelectModule },

  setup () {
    const { state, dispatch, commit } = useStore()
    const route = useRoute()

    const isModalOpen = ref(false)
    const exportType = ref({ id: 1, name: 'pdf' })

    const currentProject = computed(() => state.project.currentProject)
    const settings = computed(() => state.settings.settings)
    const share = computed(() => state.project.share)

    function open () {
      preventBodyScroll(true)
      isModalOpen.value = true
    }

    function close () {
      preventBodyScroll(false)
      isModalOpen.value = false
    }

    function download (url) {
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${currentProject.value.title}`)
      link.click()
    }

    function updateHtml () {
      if (route.name === 'Share') return

      commit('loading', true)

      return dispatch('editProject', {
        id: currentProject.value.id,
        data: {
          title: currentProject.value.title,
          html: generateHTML(currentProject.value.body, settings.value, currentProject.value.title)
        }
      })
    }

    async function _exportPdf () {
      await updateHtml()

      commit('loading', true)

      if (route.name === 'Share') {
        return projectService.exportSharedProjectAsPdf(currentProject.value.id, share.value.id)
      }

      return projectService.exportPdf(currentProject.value.id)
    }

    async function _exportDocx () {
      await updateHtml()

      commit('loading', true)

      if (route.name === 'Share') {
        return projectService.exportSharedProjectAsDocx(currentProject.value.id, share.value.id)
      }

      return projectService.exportDocx(currentProject.value.id)
    }

    function exportFile () {
      if (exportType.value.name === 'docx') {
        _exportDocx().then(res => {
          download(res.data.url)
          close()
        })
      } else {
        _exportPdf().then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          download(url)
          close()
        })
      }
    }

    return {
      // refs
      isModalOpen,
      exportType,
      // function
      open,
      close,
      download,
      updateHtml,
      exportFile
    }
  }
})
</script>
